import { Playground, Props } from 'docz';
import { Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};